import { EventEmitter } from 'eventemitter3';
import { ApiClient } from './api-client.js';
import { EncryptedValue, computeSharedSecret, generateKeyPair, verifySignature } from './encryption.js';
import { fromTypedJSON } from './serialization.js';
import { AuthenticateSubscriberRequest, PubSubMessage } from './types.js';
import { TypedWebSocket } from './ws.js';
export class Subscriber extends EventEmitter {
    config;
    apiClient;
    keys = generateKeyPair();
    ws;
    constructor(config) {
        super();
        this.config = config;
        this.apiClient = new ApiClient(config.apiUrl);
    }
    async connect() {
        if (this.ws) {
            this.ws.close();
            delete this.ws;
        }
        const { tenantId, tenantPublicKey, subject } = this.config;
        console.debug({ connect: { tenantId, publicKey: this.keys.publicKey, subject } });
        // Obtain a token authorizing read access to the subject
        const authResponse = await this.apiClient.authorize(tenantId, this.keys.publicKey, subject);
        // Initiate subscription, obtaining a one time use encryption key and gateway
        const subscribeResponse = await this.apiClient.subscribe(tenantId, this.keys.publicKey);
        // Encrypt the token with the one time use key
        const sharedKey = computeSharedSecret(this.keys.privateKey, subscribeResponse.publicKey);
        const encryptedValue = EncryptedValue.encrypt(sharedKey, authResponse.token);
        const gateway = subscribeResponse.gateway;
        // Connect to a gateway
        const req = new AuthenticateSubscriberRequest({
            tenantId,
            publicKey: this.keys.publicKey,
            ...encryptedValue.toJSON(),
        });
        this.ws = new TypedWebSocket(gateway, req);
        console.debug({ gateway });
        // Listen for published messages
        this.ws.listen(PubSubMessage, async (message) => {
            const { tenantId, publisherPublicKey, subscriberPublicKey, subject, signature, ...encrypted } = message;
            const envelope = { tenantId, publisherPublicKey, subscriberPublicKey, subject };
            // Verify the signature attached to the envelope proving this message originates from a holder of the tenant's signing key
            if (!verifySignature(tenantPublicKey, JSON.stringify(envelope), signature)) {
                console.error('Received message from unverified publisher');
                return;
            }
            // We can trust the public key now, so use it to derive a shared key for decryption and decrypt the message
            const sharedKey = computeSharedSecret(this.keys.privateKey, publisherPublicKey);
            const encryptedValue = EncryptedValue.decode(encrypted);
            const cleartext = encryptedValue.decrypt(sharedKey);
            this.emit('message', cleartext);
        });
        this.ws.onClose(() => this.connect());
    }
    onMessage(listener) {
        this.on('message', listener);
    }
    onTypedMessage(ctr, cb) {
        this.on('message', (data) => {
            try {
                const model = fromTypedJSON(ctr, data.toString());
                if (model !== undefined) {
                    cb(model);
                }
                else {
                    console.warn(`Received unrecognized pubsub message: ${data.toString()}`);
                }
            }
            catch {
                console.warn(`Received invalid pubsub message: ${data.toString()}`);
            }
        });
    }
}
//# sourceMappingURL=subscriber.js.map